export const SET_DISPLAY_BENCHMARK_DETAILS = 'SET_DISPLAY_BENCHMARK_DETAILS';

export const setDisplayBenchmarkDetails = bool => ({
  type: SET_DISPLAY_BENCHMARK_DETAILS,
  displayBenchmarkDetails: bool,
});
